
<template>
      <div class="car-rute car-con">
            <div class="title">
                <img src="//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/t4.png" alt="">
            </div>
            <div class="rule">
                <ul>
                    <li v-for="(gzitem,index) in ruletxt" :key="index" v-html="gzitem.title"></li>
                </ul>
            </div>
        </div>
</template>

<script>
export default {
  props:[''],
  data () {
      return {
        ruletxt:'',
        apiCode:{
                  guangg:['event_2019_nhcard_rule'],//广告推荐位默认大网的
                  guanggxd:['event2019_JK_rule'],//小店集卡规则
                  guanggul:['event_2019_nhcard_rule'],//大网集卡规则
        },
      }
    },
    created(){
      var m=this;
       if(this.BASE.$browser().ylxd){
           m.apiCode.guangg=m.apiCode.guanggxd
       }
      //  查询参加人数
       this.HTTP.dwRecommond(m.apiCode.guangg,'2002').then((res) => {
             for(var i=0;i<res.body[m.apiCode.guangg].length;i++){
                                res.body[m.apiCode.guangg][i].title=res.body[m.apiCode.guangg][i].title.replace(/&/g,'<br>');
                            }
            m.ruletxt = res.body[m.apiCode.guangg];
        }, (err) => {
            console.log(err);
        });
    },  
}
</script>

<style scoped>
.car-con{
    width: 100%;
    overflow: hidden;
    padding-bottom: .5rem;
}
.car-con .title{
    width: 100%;
    text-align: center;
}
.car-con .title img{
    height: .88rem;
    width:auto;
    display: inline-block;
}
/* 活动规则 */
.rule{
    display: block;
    width: 94.6%;
    margin: 0 auto;
    background-color:#A20D18;
    padding: .22rem;
    margin-top: .22rem;
    border-radius: .2rem;
    box-sizing: border-box;
    position: relative;
}
.rule::before,.rule::after{
    display: block;
    content: '';
    width: 100%;
    height: .18rem;
    position: absolute;
    left: 0;
}
.rule::before{
    top: 0;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/i7.png) no-repeat center;
    background-size: 100% 100%;
}
.rule::after{
    bottom: 0;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/i6.png) no-repeat center;
    background-size: 100% 100%;
}
.rule ul{
    display: block;
    width: 100%;
}
.rule ul li{
    padding-left: 1em;
    text-indent: -1em;
    line-height: .36rem;
    font-size: .24rem;
    text-align: justify;
    color: #FFEBCD;
    font-family: 'Microsoft yahei';
}
</style>



// WEBPACK FOOTER //
// src/components/commont/rules.vue